export default "__VITE_ASSET__qSprdKCw__"